<!-- Loading Indicator — z-[100] so it sits ABOVE modal popups (which
     use z-50 for the base modal and z-60 for stacked reveals like the
     one-time secret + share-token views). Without this the commerce
     editor popup covered up "Downloading WC subscriptions" and other
     long-running progress indicators. Mike 2026-07-07. -->
<div *ngIf="is_loading" class="w-screen h-screen fixed top-0 right-0 z-[100] bg-app-black-100/70 flex items-center justify-center">
  <div class="text-sm text-gray-300 py-6 px-8 rounded-md select-none border-1 border-app-black-200 bg-app-black-100 flex items-center min-w-[280px]">
    <i class="fas fa-cloud fa-beat-fade mr-8 text-app-teal-100" style="--fa-beat-fade-opacity: 0.1; --fa-beat-fade-scale: 1.25;"></i>
    <ul class="flex-1">
      <li *ngFor="let msg of loadingService.messages" class="py-1">
        <div>{{ msg.text }}</div>
        <!-- Optional progress: determinate bar when msg.progress is a
             number, plus sub-line for "X / Y" style detail. Driven by
             LoadingService.setProgress(id, fraction, sub). -->
        <div *ngIf="msg.progress !== undefined || msg.sub" class="mt-1">
          <div *ngIf="msg.progress !== undefined" class="w-full h-1.5 bg-app-black-200 rounded overflow-hidden">
            <div class="h-full bg-app-teal-100 transition-[width] duration-300 ease-out"
                 [style.width.%]="(msg.progress * 100) | number:'1.0-0'"></div>
          </div>
          <div *ngIf="msg.sub" class="mt-0.5 text-[10px] uppercase tracking-wide text-gray-400">
            {{ msg.sub }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<!-- Main App -->
<div *ngIf="authService.get_standalone_route() != true" class="antialiased h-screen w-screen select-none dark:bg-app-black-100">
  <nav class="px-4 py-2.5 fixed left-0 right-0 top-0 z-50
    border-b dark:border-[#434863]
    dark:bg-app-black-100
    dark:text-app-gray-300">
    <div class="flex flex-wrap justify-between items-center">
      <div class="flex justify-start items-center">
        <button *ngIf="authService.is_logged_in()"
          data-drawer-target="drawer-navigation"
          data-drawer-toggle="drawer-navigation"
          aria-controls="drawer-navigation"
          class="p-2 mr-2 text-gray-600 rounded-sm cursor-pointer md:hidden hover:text-gray-900 hover:bg-gray-100 focus:bg-gray-100 dark:focus:bg-gray-700 focus:ring-2 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-gray-400 dark:hover:bg-app-blue-100/50 dark:hover:text-white"
        >
          <svg
            class="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <svg
            class="hidden w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="sr-only">Toggle sidebar</span>
        </button>
        <a href="#" class="flex items-center justify-between mr-4">
          <!-- <img
            src="https://flowbite.s3.amazonaws.com/logo.svg"
            class="mr-3 h-8"
            alt="Flowbite Logo"
          /> -->
          <span class="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">F2 Tech</span>
        </a>
        <!-- <form action="#" method="GET" class="hidden md:block md:pl-2">
          <label for="topbar-search" class="sr-only">Search</label>
          <div class="relative md:w-56 md:w-96">
            <div
              class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none"
            >
              <svg
                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              name="email"
              id="topbar-search"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              placeholder="Search"
            />
          </div>
        </form> -->
      </div>
      <!-- Account coin — shared `<f2-account-menu>` from f2tech-shared
           so every SPA (scanners, admin, clients, members shell)
           renders the same coin + hover pill + dropdown. The pill
           shows "First Last" on top with the email as a smaller
           subtext when firstName/lastName are populated. Mike 2026-
           07-03: inline Flowbite dropdown swallowed the Sign out
           click, AND showed email-only instead of the name+email
           two-line identity. Switching to the shared component
           enforces the identity contract fleet-wide + gives us the
           tested sign-out handler. Mirror of f2-clients app.component. -->
      <div *ngIf="authService.is_logged_in()" class="flex items-center lg:order-2">
        <f2-account-menu
          [email]="authService.get_email()"
          [firstName]="authService.get_first_name()"
          [lastName]="authService.get_last_name()"
          [customItems]="crossAppMenuItems()"
          (signOut)="authService.logout()"
          (changePassword)="onChangePassword()">
        </f2-account-menu>
      </div>
    </div>
  </nav>

  <!-- Sidebar -->
  <aside *ngIf="authService.is_logged_in()"
    class="fixed top-0 left-0 z-40 w-56 h-screen pt-13 transition-transform -translate-x-full
    border dark:border-[#434863] md:translate-x-0
    dark:bg-transparent"
    aria-label="Sidenav"
    id="drawer-navigation"
  >
    <div class="overflow-y-auto py-5 px-3 h-full
    dark:bg-gradient-to-br from-app-black-100 to-app-black-500">
      <!-- <form action="#" method="GET" class="md:hidden mb-2">
        <label for="sidebar-search" class="sr-only">Search</label>
        <div class="relative">
          <div
            class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none"
          >
            <svg
              class="w-5 h-5 text-gray-500 dark:text-gray-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              ></path>
            </svg>
          </div>
          <input
            type="text"
            name="search"
            id="sidebar-search"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            placeholder="Search"
          />
        </div>
      </form> -->
      <ul class="space-y-2 text-md">
        <li>
          <a routerLink="/home" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm dark:text-white hover:bg-gray-100 dark:hover:bg-app-blue-100/50 group">
            <span class="">
              <i class="fa-solid fa-home fa-fw text-gray-400 mr-3"></i>
              Dashboard
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/data-agreements" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm dark:text-white hover:bg-gray-100 dark:hover:bg-app-blue-100/50 group">
            <span class="">
              <i class="fa-solid fa-signature fa-fw text-gray-400 mr-3"></i>
              Data Agreements
            </span>
          </a>
        </li>
        <!-- Example with sub items -->
        <!-- <li>
          <button
            type="button"
            class="flex items-center p-2 w-full font-medium text-gray-900 rounded-sm transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-app-blue-100/50"
            aria-controls="dropdown-pages"
            data-collapse-toggle="dropdown-pages"
          >
            <svg
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span class="flex-1 ml-3 text-left whitespace-nowrap"
              >Pages</span
            >
            <svg
              class="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </button>
          <ul id="dropdown-pages" class="hidden py-2 space-y-2">
            <li>
              <a
                href="#"
                class="flex items-center p-2 pl-11 w-full font-medium text-gray-900 rounded-sm transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-app-blue-100/50"
                >Settings</a
              >
            </li>
            <li>
              <a
                href="#"
                class="flex items-center p-2 pl-11 w-full font-medium text-gray-900 rounded-sm transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-app-blue-100/50"
                >Kanban</a
              >
            </li>
            <li>
              <a
                href="#"
                class="flex items-center p-2 pl-11 w-full font-medium text-gray-900 rounded-sm transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-app-blue-100/50"
                >Calendar</a
              >
            </li>
          </ul>
        </li> -->
      </ul>
      <!-- Personal pinned scanners — sits above the admin nav so it's
           always in reach. Each pin is a routerLink to /admin/pinned/:key
           (iframe route) + a small button that opens the URL in a new
           tab. Manage pins takes the user to /admin/pinned. (IT-F2-52) -->
      <ng-container *ngIf="userPreferences.pinnedScanners() as pins">
        <ul *ngIf="pins.length > 0" class="pt-5 mt-5 space-y-1 text-md border-t border-gray-200 dark:border-gray-600">
          <!-- Collapsible section header. Clicking toggles state, persisted
               to localStorage so the sidebar remembers the operator's
               preference across reloads. Chevron rotates based on state. -->
          <li>
            <button type="button"
              class="w-full flex items-center gap-1.5 px-2 pb-1 text-[10px] uppercase text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition"
              (click)="userPreferences.toggleSidebarCollapsed()"
              [attr.aria-expanded]="!userPreferences.sidebarCollapsed()"
              [attr.title]="userPreferences.sidebarCollapsed() ? 'Expand pinned' : 'Collapse pinned'">
              <i class="fa-solid fa-thumbtack text-app-teal-100"></i>
              <span class="flex-1 text-left">Pinned</span>
              <span class="text-[10px] text-gray-500 dark:text-gray-400">{{ pins.length }}</span>
              <i class="fa-solid text-[10px] transition-transform" [ngClass]="userPreferences.sidebarCollapsed() ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
            </button>
          </li>

          <ng-container *ngIf="!userPreferences.sidebarCollapsed()">
            <li *ngFor="let pin of pins" class="group">
              <div class="flex items-stretch rounded-sm hover:bg-gray-100 dark:hover:bg-app-blue-100/50">
                <a [routerLink]="['/admin/pinned', pin.key]" routerLinkActive="active-route"
                  class="flex-1 flex items-center p-2 font-medium text-gray-900 dark:text-white transition duration-75 truncate">
                  <i class="fa-solid fa-thumbtack fa-fw text-gray-400 mr-3 dark:text-app-teal-100 text-xs"></i>
                  <span class="truncate">{{ pin.label }}</span>
                </a>
                <!-- Open-in-new-tab mints a sid first so the operator SSO-
                     lands into the target. Best-effort — on mint failure
                     we still open the raw URL. -->
                <button type="button"
                  class="flex items-center px-2 text-gray-400 hover:text-gray-900 dark:hover:text-white transition"
                  (click)="openPinnedInNewTab(pin, $event)"
                  [attr.title]="'Open ' + pin.label + ' in a new tab'">
                  <i class="fa-solid fa-arrow-up-right-from-square text-xs"></i>
                </button>
              </div>
            </li>
            <li>
              <a routerLink="/admin/pinned" routerLinkActive="active-route"
                class="flex items-center p-2 text-xs text-gray-500 dark:text-gray-400 rounded-sm transition hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:hover:text-white">
                <i class="fa-solid fa-gear fa-fw text-gray-400 mr-3 text-xs"></i>
                Manage pins
              </a>
            </li>
          </ng-container>
        </ul>
        <!-- No pins yet — surface a compact "Add pinned scanners" link so
             the operator can find the manage page. -->
        <ul *ngIf="pins.length === 0 && userPreferences.loaded()" class="pt-5 mt-5 text-md border-t border-gray-200 dark:border-gray-600">
          <li>
            <a routerLink="/admin/pinned" routerLinkActive="active-route"
              class="flex items-center p-2 text-xs text-gray-500 dark:text-gray-400 rounded-sm transition hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:hover:text-white">
              <i class="fa-solid fa-thumbtack fa-fw text-gray-400 mr-3 text-xs"></i>
              Add pinned scanners
            </a>
          </li>
        </ul>
      </ng-container>

      <!-- Admin only nav -->
      <ul *ngIf="authService.is_admin()" class="pt-5 mt-5 space-y-2 text-md border-t border-gray-200 dark:border-gray-600">
        <li>
          <a routerLink="/admin/users" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group">
            <span class="">
              <i class="fa-solid fa-users fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Users
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/scanners" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-list fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Scanners
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/common-data" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-database fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Common Data
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/customer-directory" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-building fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Customers
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/customer-assets" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-paperclip fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Customer Assets
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/sso-tester" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-vial fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              SSO Tester
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/error-reports" routerLinkActive="active-route"
             (click)="onNavToTrackedPanel('error_reports')"
             class="flex items-center justify-between gap-2 p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="whitespace-nowrap">
              <i class="fa-solid fa-triangle-exclamation fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Error Reports
            </span>
            <ng-container *ngIf="((userPrefsState$ | async)?.unread?.error_reports || 0) > 0">
              <span class="shrink-0 inline-flex items-center justify-center w-5 h-5 px-1
                           rounded-full text-[11px] font-bold leading-none
                           bg-red-600 text-white shadow ring-1 ring-red-500/60">
                {{ badgeText((userPrefsState$ | async)?.unread?.error_reports) }}
              </span>
            </ng-container>
          </a>
        </li>
        <li>
          <a routerLink="/admin/services" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-server fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Services
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/commerce-events" routerLinkActive="active-route"
             (click)="onNavToTrackedPanel('commerce_events')"
             class="flex items-center justify-between gap-2 p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="whitespace-nowrap">
              <i class="fa-solid fa-receipt fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Commerce Events
            </span>
            <ng-container *ngIf="((userPrefsState$ | async)?.unread?.commerce_events || 0) > 0">
              <span class="shrink-0 inline-flex items-center justify-center w-5 h-5 px-1
                           rounded-full text-[11px] font-bold leading-none
                           bg-red-600 text-white shadow ring-1 ring-red-500/60">
                {{ badgeText((userPrefsState$ | async)?.unread?.commerce_events) }}
              </span>
            </ng-container>
          </a>
        </li>
        <li>
          <a routerLink="/admin/billing" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-file-invoice-dollar fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Billing
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/tracking" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-square-poll-vertical fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              User Tracking
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/activity" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-heart-pulse fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              User Activity
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/billing-reports" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-file-invoice-dollar fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Billing Reports
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/exchange-agreements" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-file-contract fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Compliance
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/compliance-report" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-clipboard-check fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Compliance Report
            </span>
          </a>
        </li>
        <li>
          <!-- IT-F2-426 c/2795820a (Mike 2026-10-02): pending-review
               badge driven by AgreementReviewBadgeService (60s poll +
               bump() after writes). Caps at "9+" for counts ≥ 10. -->
          <a routerLink="/admin/exchange-agreement-review" routerLinkActive="active-route"
             class="flex items-center justify-between gap-2 p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="whitespace-nowrap">
              <i class="fa-solid fa-user-check fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Agreement Review
            </span>
            <ng-container *ngIf="((reviewBadge.pending$ | async) || 0) > 0">
              <span class="shrink-0 inline-flex items-center justify-center w-5 h-5 px-1
                           rounded-full text-[11px] font-bold leading-none
                           bg-red-600 text-white shadow ring-1 ring-red-500/60"
                    title="Agreements awaiting review (pending)">
                {{ badgeText(reviewBadge.pending$ | async) }}
              </span>
            </ng-container>
          </a>
        </li>
        <li>
          <a routerLink="/admin/theotrade-billing" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-file-invoice-dollar fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              TheoTrade Billing
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/theotrade-billing-jr" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-file-invoice-dollar fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Theo Billing (JR)
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/utilities" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-screwdriver-wrench fa-fw text-gray-400 mr-3 dark:text-app-teal-100"></i>
              Admin Tools
            </span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/client-notifications" routerLinkActive="active-route" class="flex items-center p-2 font-medium text-gray-900 rounded-sm transition duration-75 hover:bg-gray-100 dark:hover:bg-app-blue-100/50 dark:text-white group" >
            <span class="">
              <i class="fa-solid fa-bell fa-fw text-gray-400 mr-3 dark:text-yellow-400"></i>
              Client Notifications
            </span>
          </a>
        </li>
      </ul>
    </div>
    <div class="hidden absolute bottom-0 left-0 justify-center p-4 space-x-4 w-full lg:flex z-20">
      <!-- <a href="#" data-tooltip-target="tooltip-settings"
        class="inline-flex justify-center p-2 text-gray-500 rounded cursor-pointer dark:text-gray-400 dark:hover:text-white hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-600"
      >
       class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
            d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </a>
      <div id="tooltip-settings" role="tooltip"
        class="inline-block absolute invisible z-10 py-2 px-3 text-sm font-medium text-white bg-gray-900 rounded-sm shadow-sm opacity-0 transition-opacity duration-300 tooltip"
      >
        Settings page
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div> -->
    </div>
  </aside>

  <main class="pt-12 md:ml-56 h-full main overflow-y-auto">
    <!-- Notifications Banner -->
    <div *ngIf="notifications && notifications.length > 0"
      class="w-full flex flex-col gap-1 bg-[#00358b] text-white">
      <div *ngFor="let n of notifications" class="w-full flex items-center px-2 py-2 border-b border-white/35">
        <i class="fa-solid fa-circle-info text-[#7bdfff] text-2xl px-2 mr-1"></i>
        <span>
          {{n.CreatedAt}} — {{n.Message}}
        </span>
      </div>
    </div>
    <router-outlet class="h-full"></router-outlet>
  </main>
</div>

<!-- Standalone version -->
<div *ngIf="authService.get_standalone_route() == true"
class="antialiased h-screen w-screen select-none main">
  <router-outlet class="h-full w-full"></router-outlet>
</div>

<!-- Cross-tab Cognito-cache sync overlay. Renders a floating banner at the
     top of the page when ANY operator triggers a full /sync-all reconcile,
     bound to SyncStateService.state$. Non-blocking — admins can keep
     working on other tabs while the sync runs. -->
<sync-overlay></sync-overlay>